import { Button, Dropdown } from '@iveco-ti/iveco-ds'
import {
  ArrowDownAZ,
  ArrowUpDown,
  ArrowUpZA,
  Check,
  ChevronDown,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { OrderBy } from '@/common/hooks/useOrderBy'
import { getNestedValue, NestedObject } from '@/common/utils/getNestedValue'

type ByDropdownProps = {
  selected: OrderBy
  onChangeOrder: (field: string, order: 'asc' | 'desc') => void
  options: { label: string; field: string }[]
}

export function OrderByDropdown({
  selected,
  onChangeOrder,
  options,
}: ByDropdownProps) {
  const { t } = useTranslation('common')

  const isSelected = (field: string, order: 'asc' | 'desc') => {
    if (!selected) return false

    // Função auxiliar para verificar um objeto NestedObject
    const checkObject = (obj: NestedObject, field: string): boolean => {
      if (field.includes('.')) {
        const value = getNestedValue(obj, field)
        return value === order
      }
      return obj[field] === order
    }

    // Se é um array, verifica se algum item tem o campo com a ordem especificada
    if (Array.isArray(selected)) {
      return selected.some((item) => checkObject(item, field))
    }

    // Se é um objeto único, verifica diretamente
    return checkObject(selected, field)
  }

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button.Root color="brand" variant="secondary" size="sm">
          <Button.Icon icon={ArrowUpDown} />
          {t('components.order_dropdown.trigger.label')}
          <Button.Icon icon={ChevronDown} />
        </Button.Root>
      </Dropdown.Trigger>

      <Dropdown.Body>
        <Dropdown.List>
          {options.map((option) => (
            <div key={option.field}>
              <Dropdown.Item
                color="brand"
                onClick={() => onChangeOrder(option.field, 'asc')}
              >
                <Dropdown.Icon icon={<ArrowDownAZ size={16} />} />
                {option.label}
                {isSelected(option.field, 'asc') && (
                  <Dropdown.Icon icon={<Check size={16} />} />
                )}
              </Dropdown.Item>

              <Dropdown.Item
                color="brand"
                onClick={() => onChangeOrder(option.field, 'desc')}
              >
                <Dropdown.Icon icon={<ArrowUpZA size={16} />} />
                {option.label}
                {isSelected(option.field, 'desc') && (
                  <Dropdown.Icon icon={<Check size={16} />} />
                )}
              </Dropdown.Item>
            </div>
          ))}
        </Dropdown.List>
      </Dropdown.Body>
    </Dropdown.Root>
  )
}
